
export default {
  grpr: null,
  loadingParcelamento: false
}
